



























import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';

@Component
export default class TooltipIcon extends Vue {
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: "Opcja zablokowana" }) disabledTooltipText!: string;
  @Prop({ default: "" }) tooltipText!: string;
  @Prop({ default: "" }) icon!: string;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: "" }) href!: string;
}
